import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { ViewportEdgeNav } from "@/components/ViewportEdgeNav";
import type { NavItem } from "@/lib/nav";

export function KontakteNav({ items }: { items: NavItem[] }) {
  return (
    <ViewportEdgeNav>
      <nav className="eh-project-detail-nav" aria-label="Kontakte">
        <ul className="eh-project-detail-nav__list" role="list">
          {items.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.href}
                className={({ isActive }) =>
                  clsx(
                    "eh-project-detail-nav__item",
                    isActive && "eh-project-detail-nav__item--active",
                  )
                }
              >
                <span className="eh-project-detail-nav__label">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </ViewportEdgeNav>
  );
}
